export const siteConfig = {
  apiBaseUrl: "",
};

export type SiteConfig = typeof siteConfig;
